import { useLocale } from '@repo/i18n';
import { TicketOptionWithQuantity, TicketType } from '@repo/types';
import { currencyAtom } from '@repo/widget-utils/currencyAtom';
import { useMemo } from 'react';
import { mapQuantitiesToSummaryPriceLines } from 'src/components/domain/summary/summary-mapping';
import { voucherAtom } from 'src/state/voucher/voucherAtom';
import { useAtom } from 'ximple';

export default function useSummaryPriceLines(
    quantities: TicketOptionWithQuantity[],
    isDetailed: boolean,
    isLoadingPrices: boolean,
    ticketType?: TicketType,
) {
    const { locale, t } = useLocale();
    const [currency] = useAtom(currencyAtom);
    const [{ appliedPromoCode }] = useAtom(voucherAtom);

    return useMemo(() => {
        return mapQuantitiesToSummaryPriceLines(
            quantities,
            appliedPromoCode,
            isLoadingPrices,
            locale,
            currency,
            t,
            isDetailed,
            ticketType,
        );
    }, [
        quantities,
        appliedPromoCode,
        isLoadingPrices,
        locale,
        currency,
        t,
        isDetailed,
        ticketType,
    ]);
}
